<template>
    <v-container fluid>
        <v-card>
            <v-toolbar color="secondary" flat dense>
                <v-toolbar-title>Stock Report</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12" xs="12" md="4">
                        <v-autocomplete name="checkStockStore" dense outlined v-model="queryStore" :items="stores"
                            label="Select Store" item-text="Name" item-value="id" @change="queryData"></v-autocomplete>
                    </v-col>
                </v-row>
                
                <v-row dense>
                    <v-col cols="12" xs="12" md="12">
                        <v-row>
                            <v-col cols="12" md="12">
                                <!-- excel icon -->
                                <download-excel :data="inventory" :fields="fields" name="Stock List">
                                    <v-icon color="green">mdi-file-excel</v-icon>
                                </download-excel>
                                <!-- end -->
                            </v-col>

                            <v-col cols="12" style="margin-top: -20px">
                                <v-text-field name="checkStockSearch" outlined dense label="Search"
                                    v-model="search"></v-text-field>
                                <!-- start of table -->
                                <v-data-table :loading="loader" loading-text="Loading Data......" :headers="headers"
                                    :items="inventory" :search="search" :items-per-page="2000">
                                    <template v-slot:item.Name="{ item }">
                                        <v-btn color="primary" text :to="`/quick-audit/${item.productId}`">{{
                                            item.Name }}</v-btn>
                                    </template>

                                </v-data-table>
                                <!-- end -->
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <!-- snackbar -->
            <snackbar ref="snackbar"></snackbar>
        </v-card>
    </v-container>
</template>


<script>
export default {
    computed: {
        activeStore() {
            return localStorage.getItem("store_id");
        },
    },
    data() {
        return {
            search: null,
            pageItems: 500,
            loader: false,
            editItem: {},
            damagedItem: {},
            transferItem: {},
            store: null,
            queryStore: null,
            stores: [],
            users: [],
            date: null,
            dialog: false,
            damageDialog: false,
            transferDialog: false,
            headers: [
                { text: "Product Name", value: "Name" },
                { text: "Available Qty", value: "AvailableQty" },
            ],
            fields: {
                Product: "Name",
                AvailableQty: "AvailableQty",
            },
            inventory: [],
        };
    },
    methods: {
        queryData() {
            const userId = localStorage.getItem("user_id");
            const id = this.queryStore;
            const self = this;
            self.loader = true;
            this.$store
                .dispatch("get", `/custom-check-stock/${id}/${userId}`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.loader = false;
                        self.inventory = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
        getStores() {
            const self = this;
            this.$store
                .dispatch("get", `/stores`)
                .then((res) => {
                    if (res.ResultCode == 1200) {
                        self.stores = res.ResponseData;
                    } else {
                        this.$refs.snackbar.show(res.msg, "red");
                    }
                })
                .catch((err) => {
                    this.$refs.snackbar.show(err, "red");
                });
        },
    },
    created() {
        Promise.all([this.getStores()]);
    },
};
</script>

<style lang="scss" scoped></style>